import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog, faCopy, faFileLines, faPencil,
} from '@fortawesome/pro-light-svg-icons'

import {
  Box, IconWithMenu, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import type { TaskListTemplateModel } from '@domain-group/realhub-backend-api-types'

import useTaskListTemplate from '@hooks/useTaskListTemplate'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

type DuplicateTaskListTemplate = {
  duplicateTaskListTemplateFn: () => void,
}

const duplicateTaskListTemplate = (params: DuplicateTaskListTemplate) => {
  const { duplicateTaskListTemplateFn } = params

  const duplicateTaskListTemplatePayload: HandleCallbackActionParams = {
    callbacks: {
      // @ts-expect-error TS2322
      action: duplicateTaskListTemplateFn,
    },
    toastText: 'Task List Template duplicated',
  }

  swal
    .fire({
      confirmButtonColor: '#43ac6a',
      confirmButtonText: 'Yes, duplicate it.',
      icon: 'success',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Duplicate Task List Template?',
    })
    .then(({ value }) => {
      if (value){
        handleCallbackAction(duplicateTaskListTemplatePayload)
      }
    })
}

interface TaskListTemplateListItemProps {
  taskListTemplate: TaskListTemplateModel,
}

const TaskListTemplate = (props: TaskListTemplateListItemProps) => {
  const { taskListTemplate, taskListTemplate: { id, title } } = props

  const useTaskListTemplatePayload = useTaskListTemplate(taskListTemplate)
  const {
    callbacks: { duplicateTaskListTemplate: duplicateTaskListTemplateFn },
    urls: { editTaskListTemplateUrl },
  } = useTaskListTemplatePayload

  return (
    <ListItem
      boxProps={{
        as: 'a', borderBottom: '1px solid', padding: 'large',
      }}
      disableHover
    >
      <Box
        alignItems="center"
        backgroundColor="backgroundColor"
        borderRadius={5}
        color="bodyFontLightColor"
        flexShrink={0}
        height={40}
        justifyContent="center"
        position="relative"
        width={40}
      >
        <FontAwesomeIcon icon={faFileLines} />
      </Box>

      <Box flexDirection="column" justifyContent="center" marginLeft="large">
        <Text fontSize="small">{title}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {`ID #${id}`}
        </Text>
      </Box>

      <Box alignItems="center" flexDirection="row" justifyContent="flex-end">
        <IconWithMenu
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faCog} />
            </Link>
          )}
        >
          {/*
           // @ts-expect-error TS2741 */}
          <IconWithMenu.Menu closeOnClick listStyle={{ right: '-7px' }}>
            <Link href={editTaskListTemplateUrl} key="edit">
              <FontAwesomeIcon icon={faPencil} /> Edit Template
            </Link>

            <Link onClick={() => duplicateTaskListTemplate({ duplicateTaskListTemplateFn })} key="duplicate">
              <FontAwesomeIcon icon={faCopy} /> Duplicate
            </Link>
          </IconWithMenu.Menu>
        </IconWithMenu>
      </Box>
    </ListItem>
  )
}

export default TaskListTemplate
